import { WebinarStatus } from '@core/types';
import { ArrowLeft } from '@core/ui';
import { dropOverviewLists, Link, useParams } from '@online-webinar/router';
import { useAppSelector } from '@online-webinar/store';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

/** To the overview tab the webinar is in now, with its card in view: upcoming while planned or live, ended after the broadcast. */
export const GoToOverviewNavigation = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { webinarId } = useParams({ strict: false });
    const status = useAppSelector((state) => state.liveWebinar.webinarData.status);
    const tab = status === WebinarStatus.Planned || status === WebinarStatus.Started ? 'upcoming' : 'ended';

    return (
        <Link
            to="/organized/$tab"
            params={{ tab }}
            state={{ showWebinar: webinarId }}
            // The overview scrolls the card into view once its list is there.
            resetScroll={false}
            // The webinar may have moved to the other list since it was cached.
            onClick={() => dropOverviewLists(queryClient)}
            className="absolute left-0 top-1/2 w-8 hover:w-40 bg-white flex items-center overflow-hidden pl-1 py-3 rounded-md text-primary text-base leading-none whitespace-nowrap transition-[width] duration-200 ease-in-out transform -translate-y-1/2"
        >
            <ArrowLeft classNames="size-5 flex-none fill-primary" />
            <span className="pl-2">{t('Button.BackToOverview')}</span>
        </Link>
    );
};
